import { FeedbackSummaryMessage, LabelType } from 'generated/graphql';

export const getMarkdownForFeedbackSummaryMessage = (
  message: FeedbackSummaryMessage | undefined,
) => {
  const markdownContent = message?.token?.content;

  if (message?.token?.details?.artefact) {
    return `:feedback-count[${
      message?.token?.details?.artefact.feedbackCount ?? 0
    }]{id=${message?.token?.details?.artefact.artefactID}}`;
  }

  if (message?.token?.details) {
    const { examples, label } = message.token.details;

    const feedbackCount = examples
      ? `:feedback-count[${examples?.count}]{id=${examples?.id}}`
      : '';

    if (label?.details.type === LabelType.Reason) {
      return `:reason[${markdownContent}]{id=${label?.details.id} responseID=${message.id}}${feedbackCount}`;
    }

    if (label?.details.type === LabelType.Aspect) {
      return `:tk[${markdownContent}]{id=${label?.details.id} responseID=${message.id}}${feedbackCount}`;
    }

    return `${markdownContent}${feedbackCount}`;
  }

  return markdownContent ?? '';
};
